<section class="container">
    <div [innerHTML]="getSafeHtml(htmlContent)"></div>
</section>

<app-footer></app-footer>